import { SVGAttributes } from "react";

export const TgSocialLogo = (props: SVGAttributes<SVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path d="M24 0V24H0V0H24Z" fill="white" fillOpacity="0.01" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.92969 4.92891C6.80312 3.05422 9.34844 2 12 2C14.6516 2 17.1969 3.05422 19.0703 4.92891C20.9453 6.80359 22 9.34891 22 12C22 14.6511 20.9453 17.1964 19.0703 19.0711C17.1969 20.9458 14.6516 22 12 22C9.34844 22 6.80312 20.9458 4.92969 19.0711C3.05469 17.1964 2 14.6511 2 12C2.00052 9.34778 3.05432 6.80434 4.92969 4.92891ZM12.3577 9.38217C11.3858 9.7867 9.44208 10.624 6.52645 11.894C6.05302 12.0823 5.80458 12.2665 5.7827 12.4465C5.74423 12.7506 6.12504 12.8705 6.6425 13.0335C6.71347 13.0559 6.78701 13.079 6.86239 13.1036C7.37333 13.2695 8.06083 13.4637 8.41708 13.4714C8.74208 13.4784 9.10302 13.3448 9.50145 13.0708C12.2265 11.2322 13.6311 10.3028 13.7202 10.2828C13.7827 10.2687 13.8686 10.2509 13.9265 10.3029C13.9858 10.3548 13.9796 10.4533 13.9733 10.4797C13.9365 10.6403 12.4462 12.0258 11.6707 12.7468C11.4269 12.9735 11.2538 13.1345 11.2186 13.1711C11.1402 13.2526 11.0601 13.3297 10.9832 13.4039C10.5091 13.861 10.1533 14.2039 11.003 14.7637C11.415 15.0351 11.7439 15.2591 12.0725 15.483C12.4257 15.7235 12.7786 15.9639 13.2343 16.2628C13.3514 16.3396 13.4633 16.4193 13.5723 16.497C13.9864 16.7922 14.3585 17.0574 14.8186 17.0151C15.0858 16.9906 15.3624 16.7394 15.5015 15.99C15.8327 14.2189 16.4843 10.3817 16.6343 8.80045C16.6483 8.66201 16.6311 8.48467 16.6186 8.40686C16.6046 8.32897 16.5765 8.21803 16.4765 8.136C16.3561 8.03873 16.1718 8.01826 16.089 8.01959C15.7124 8.02639 15.1358 8.22701 12.3577 9.38217Z"
        fill="var(--g-color-text-primary)"
      />
    </svg>
  );
};
